// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"2ce22c7f","201":"e0b3edbf","203":"f9165285","206":"7d6e2dcf","394":"f55b2b6a","536":"9f284fb3","798":"71f7b16e","914":"5d37509e"}[chunkId] + ".chunk.js";
};